import { render, staticRenderFns } from "./filingInfo.vue?vue&type=template&id=58482c18&scoped=true&"
import script from "./filingInfo.vue?vue&type=script&lang=js&"
export * from "./filingInfo.vue?vue&type=script&lang=js&"
import style0 from "./filingInfo.vue?vue&type=style&index=0&id=58482c18&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58482c18",
  null
  
)

export default component.exports